import { Button, Grid, Typography } from "@mui/material";
import Input from "./Input";
import { Controller, FieldValues, useForm } from "react-hook-form";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import { useNavigate } from "react-router-dom";

export interface SendEmailRecoverData {
  email: string;
}

interface SendEmailRecoverProps {
  onSubmit: (data: SendEmailRecoverData) => void;
  isLoading: boolean;
}

const SendEmailRecover = ({ onSubmit, isLoading }: SendEmailRecoverProps) => {
  const { handleSubmit, control } = useForm<SendEmailRecoverData>();
  const onSubmitHandler = (data: SendEmailRecoverData) => {
    onSubmit(data);
  };
  const navigate = useNavigate();

  return (
    <form onSubmit={handleSubmit(onSubmitHandler)}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 12 }}>
          <Controller
            control={control}
            rules={{
              required: "El correo electrónico es requerido",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Debe ser un email válido",
              },
            }}
            name="email"
            render={({ field, fieldState }) => (
              <Input
                label="Usuario"
                name="username"
                required
                field={field}
                error={fieldState.error?.message}
                icon={<AlternateEmailIcon />}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 12 }}>
          <Typography
            variant="body2"
            sx={{
              textAlign: "left",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => {
              navigate("/login");
            }}
          >
            Ir a inicio de sesión
          </Typography>
        </Grid>
      </Grid>

      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          disabled={isLoading}
          loading={isLoading}
        >
          Ingresar
        </Button>
      </Grid>
    </form>
  );
};

export default SendEmailRecover;
